import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import KpiTile, { KPI_TILE_VARIANTS } from '../../../components/molecules/KpiTile';
import ArtifactLoader from './ArtifactLoader';
import { formatKpiValue, formatKpiDelta } from './kpiFormat';
import { parseArtifactData } from './parseArtifactData';
import css from './KpiArtifact.css';

const DELTA_VARIANTS = {
    up: KPI_TILE_VARIANTS.POSITIVE,
    down: KPI_TILE_VARIANTS.NEGATIVE,
    flat: KPI_TILE_VARIANTS.NEUTRAL,
};

const KpiCard = ({ item }) => {
    const delta = formatKpiDelta(item.delta);

    return (
        <KpiTile
            label={item.label}
            value={formatKpiValue(item.value, item.format, item.unit)}
            valueTooltip={formatKpiValue(item.value, item.format, item.unit, { compact: false })}
            delta={delta ? { text: delta.text, direction: delta.direction, variant: DELTA_VARIANTS[delta.direction] } : null}
            comparisonLabel={item.comparison_label}
        />
    );
};

KpiCard.propTypes = {
    item: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        format: PropTypes.string,
        unit: PropTypes.string,
        delta: PropTypes.number,
        comparison_label: PropTypes.string,
    }).isRequired,
};

export const KpiArtifactInner = ({ data }) => {
    const parsed = useMemo(() => parseArtifactData(data), [data]);

    const items = Array.isArray(parsed?.items) ? parsed.items : [];

    if (!items.length) {
        return <div className={css.placeholder}>KPI data not available</div>;
    }

    return (
        <div className={css.cards}>
            {items.map((item, index) => (
                <KpiCard key={`${item.label}-${index}`} item={item} />
            ))}
        </div>
    );
};

KpiArtifactInner.propTypes = {
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

const KpiArtifact = ({ artifact }) => (
    <ArtifactLoader artifact={artifact}>{data => <KpiArtifactInner data={data} />}</ArtifactLoader>
);

KpiArtifact.propTypes = {
    artifact: PropTypes.shape({
        data: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        content_url: PropTypes.string,
    }).isRequired,
};

export default KpiArtifact;
